import { useEffect, useState } from 'react';
import TypeIdService from '../../../services/typeId_service';
import RoleService from '../../../services/role_service';
import CountryService from '../../../services/country_service';
import ThematicAreaService from '../../../services/thematicArea_service';
import MotivationService from '../../../services/motivation_service';

const Catalogs = ({ canAssignRole, isEditorRoleAdministrator, message }) => {
  const [typeIds, setTypeIds] = useState([]);
  const [countries, setCountries] = useState([]);
  const [thematicAreas, setThematicAreas] = useState([]);
  const [motivations, setMotivations] = useState([]);
  const [roles, setRoles] = useState([]);

  const loadLists = async () => {
    try {
      const [
        typeIdsData,
        rolesData,
        countriesData,
        thematicAreasData,
        motivationsData,
      ] = await Promise.all([
        TypeIdService.getAll(),
        RoleService.getAll(),
        CountryService.getAll(),
        ThematicAreaService.getAll(),
        MotivationService.getAll(),
      ]);
      setTypeIds(typeIdsData ?? []);
      setCountries(countriesData ?? []);
      setThematicAreas(thematicAreasData ?? []);
      setMotivations(motivationsData ?? []);
      let rolesUpdate = (rolesData ?? []).filter((r) => r.Name !== 'Super Administrador');
      if (!canAssignRole) rolesUpdate = [];
      if (canAssignRole && !isEditorRoleAdministrator) {
        rolesUpdate = rolesUpdate.filter((r) => r.Name !== 'Administrador');
      }
      setRoles(rolesUpdate);
    } catch (e) {
      message(e?.message || e, "error");
    }
  }

  useEffect(() => {loadLists()}, [canAssignRole, isEditorRoleAdministrator]);

  return {
    typeIds,
    countries,
    thematicAreas,
    motivations,
    roles,
  };
};

export default Catalogs;
